import React, { useContext, useEffect, useRef } from "react"
import { useIntercom } from "react-use-intercom"
import { isImpersonating, withAuthProvider } from "../lib/auth"
import { UserContext } from "../lib/UserProvider/"

const resolveSession = ({ impersonating, isLoggedIn, intercomUserJwt }) => {
  if (impersonating) return { kind: "off" }
  if (isLoggedIn && intercomUserJwt) {
    return { kind: "verified", jwt: intercomUserJwt }
  }
  return { kind: "anonymous" }
}

const IntercomIdentity = ({ isLoggedIn }) => {
  const { boot, shutdown, hardShutdown } = useIntercom()
  const { user } = useContext(UserContext)
  const { kind, jwt } = resolveSession({
    impersonating: isImpersonating(),
    isLoggedIn,
    intercomUserJwt: user?.intercomUserJwt,
  })
  const appliedSessionRef = useRef(null)

  useEffect(() => {
    const previous = appliedSessionRef.current
    if (
      previous &&
      previous.kind === kind &&
      (kind !== "verified" || previous.jwt === jwt)
    ) {
      return
    }

    if (kind === "off") {
      hardShutdown()
    } else {
      if (previous && previous.kind !== "off") {
        shutdown()
      }
      if (kind === "verified") {
        boot({ intercomUserJwt: jwt })
      } else {
        boot()
      }
    }

    appliedSessionRef.current = { kind, jwt }
  }, [kind, jwt, boot, shutdown, hardShutdown])

  return null
}

const IntercomWithAuth = withAuthProvider(IntercomIdentity)

IntercomWithAuth.displayName = "withAuthProvider(IntercomIdentity)"
export default IntercomWithAuth
